




import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';

@Component
export default class Logo extends Vue {
  private closeCart() {
    return { redirect: '/' };
  }

    get logoSrc(): boolean {
        return store.state.options.logo;
    }

}
